// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import Gallery from '../Gallery';
import DealerInfo from '../DealerInfo';
import classNames from 'classnames';
import styles from 'components/GalleryModal.scss';

/**
 * GalleryModal React component.
 */
class GalleryModal extends PureComponent<*, *> {
  itemsLength: number;
  /**
   *  Props implementation.
   */
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    classModal: PropTypes.string,
    headline: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pictures: PropTypes.array.isRequired,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    activeItemIndex: PropTypes.number,
    targetScroll: PropTypes.object,
    onChange: PropTypes.func,
    setDealerFormType: PropTypes.func,
    buttonOnClick: PropTypes.func,
    gtmSectionName: PropTypes.string.isRequired
  };

  /**
   * Props implementation.
   * @param {object} props - component props
   */
  constructor(props: Object) {
    super(props);
    this.itemsLength = this.props.pictures ? this.props.pictures.length : 0;

    this.state = {
      activeItemIndex: this.props.activeItemIndex || 0
    };
  }

  /**
   * navigates to new slide
   * @param {string} direction - previous or next
   * @return {void}
   */
  handleNavigate = (direction: string) => {
    const { activeItemIndex } = this.state;
    let newIndex = 0;
    if (direction === 'previous') {
      newIndex = activeItemIndex - 1 === -1 ? 0 : activeItemIndex - 1;
    } else {
      newIndex =
        activeItemIndex + 1 === this.itemsLength
          ? this.itemsLength
          : activeItemIndex + 1;
    }
    this.setState({ activeItemIndex: newIndex });
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const { pictures, headline, price, targetScroll } = this.props;
    const {
      classGalleryModal,
      classGalleryModalLeft,
      classGalleryModalRight,
      classGalleryH2
    } = styles;

    return pictures ? (
      <Modal {...this.props} closeIcon={'close'}>
        <div className={classNames(classGalleryModal)}>
          <div className={classNames(classGalleryModalLeft)}>
            <h2 className={classGalleryH2}>{headline}</h2>
            <Gallery pictures={pictures} onChange={this.props.onChange} />
          </div>
          <div className={classNames(classGalleryModalRight)}>
            <h2 className={classGalleryH2}>{price} </h2>
            <DealerInfo
              colorIcons={'light'}
              targetScroll={targetScroll}
              changeFormTypeFunc={this.props.setDealerFormType}
              buttonOnClick={this.props.buttonOnClick}
              gtmSectionName="Gallery"
            />
            {this.props.children}
          </div>
        </div>
      </Modal>
    ) : null;
  }
}

export default GalleryModal;



// WEBPACK FOOTER //
// ./src/Common/GalleryModal/index.js